var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PEC_jumper"},[_vm._v(" 正在跳转...... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }